export default __webpack_public_path__ + "static/media/hatom-screenshots.babf7a95.jpg";